export enum ContractStatus {
    ARCHIVED = 'ARCHIVED',
    SUSPENDED = 'SUSPENDED',
    PENDING = 'PENDING',
    ACTIVATED = 'ACTIVATED',
}
